import clsx from 'clsx';
import Style from './container.module.scss';
import { useNode } from '@craftjs/core';
import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';

export const Container: FormContainerComponent = ({ children, title }) => {
  const { styles } = useNode((node) => ({
    styles: node.data.custom,
  }));

  return (
    <div>
      {title && <div className={Style.title}>{title}</div>}
      <div className={clsx(Style.container, 'form-fill--container')} style={styles}>
        {children}
      </div>
    </div>
  );
};
